export enum ReportSummaryEnum {
    "EMPTY" = "EMPTY",
    "FRONT_COVER" = "FRONT_COVER",
    "EVALUATION" = "EVALUATION",
    "SUMMARY" = "SUMMARY",
    "COMPANY" = "COMPANY",
    "ANALYSIS" = "ANALYSIS",
    "TEXT" = "TEXT",
    "SIGNS" = "SIGNS",
    "APPEND" = "APPEND",
    "BACK_COVER" = "BACK_COVER",
    "METHODS" = "METHODS",
}

export enum AnalysisEnum {
    "TABLE" = "TABLE",
}

export enum NumberOfEmployees {
    "0_20" = "0_20",
    "21_50" = "20_50",
    "51_100" = "51_100",
    "101_500" = "101_500",
    "501_1000" = "501_1000",
    "1001_5000" = "1001_5000",
    "5001_MORE" = "5001_MORE",
}

export enum ItemStatusEnum {
    AVAILABLE = 'AVAILABLE',
    UNAVAILABLE = 'UNAVAILABLE',
    RESERVED = 'RESERVED',
    IN_USE = 'IN_USE',
    USED = 'USED',
    DEFECT = 'DEFECT',
    BROKEN = 'BROKEN',
}

export enum EquipmentEnum {
    EQUIPMENT = 'EQUIPMENT',
    ACCESSORY = 'ACCESSORY',
}

export enum QuestionTypeEnum {
    TITLE = 'TITLE',
    INPUT = 'INPUT',
    TEXTAREA = 'TEXTAREA',
    SELECT = 'SELECT',
    RADIO = 'RADIO',
    CHECKBOX = 'CHECKBOX',
    PHOTO = 'PHOTO',
    SIGN = 'SIGN',
}

export enum QuestionFileEnum {
    DOCUMENT = 'DOCUMENT',
    IMAGE = 'IMAGE',
}

export enum EvaluationStatusEnum {
    CANCELED = 'CANCELED',
    CONCLUDED = 'CONCLUDED',
    FINISHED = 'FINISHED',
    PENDING = 'PENDING',
    STARTED = 'STARTED',
}

export enum AnalysisStatusEnum {
    CANCELED = 'CANCELED',
    CONCLUDED = 'CONCLUDED',
    PAUSED = 'PAUSED',
    PENDING = 'PENDING',
    STARTED = 'STARTED',
}
